import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Pick } from "@/components/vi/SaleDialog";
import { call } from "@/lib/vi";
import { Wand2, Save } from "lucide-react";

// Édition du cercle de zone d'un circuit ; le centre se pose en cliquant sur la carte (via onDraftChange)
export default function ZoneEditor({ circuits, zones, draft, onDraftChange, onSaved }) {
  const [cid, setCid] = useState("");
  const pick = (v) => {
    setCid(v);
    const z = zones.find((x) => x.id === v)?.zone_geo;
    onDraftChange(!v ? null : z ? { lat: z.lat, lng: z.lng, rayon_km: z.rayon_km } : { rayon_km: 2 });
  };
  const suggest = async () => {
    const r = await call(() => api.get(`/itinerant/circuits/${cid}/zone/suggest`), null);
    if (r) onDraftChange({ lat: r.lat, lng: r.lng, rayon_km: r.rayon_km });
  };
  const save = async () => {
    const r = await call(() => api.put(`/itinerant/circuits/${cid}/zone`, { lat: draft.lat, lng: draft.lng, rayon_km: Number(draft.rayon_km) }), "Zone du circuit enregistrée");
    if (r) { pick(""); onSaved(); }
  };
  return (
    <div className="flex flex-wrap items-end gap-2" data-testid="zone-editor">
      <div className="w-60"><Pick value={cid} onChange={pick} placeholder="Définir la zone d'un circuit…" testid="zone-circuit-select"
        options={circuits.map((c) => ({ value: c.id, label: `${c.nom}${zones.some((z) => z.id === c.id) ? " ✓" : ""}` }))} /></div>
      {cid && <>
        <Button variant="outline" size="sm" onClick={suggest} data-testid="zone-suggest"><Wand2 className="h-4 w-4 mr-1" />Pré-remplir</Button>
        <label className="text-xs">Rayon (km)<input type="number" step="0.1" min="0.1" className="ml-1 w-20 rounded-md border px-2 py-1 text-sm" value={draft?.rayon_km ?? ""} disabled={!draft}
          onChange={(e) => onDraftChange({ ...draft, rayon_km: e.target.value })} data-testid="zone-radius" /></label>
        <Button size="sm" className="bg-brand-600 hover:bg-brand-700 text-white" onClick={save} disabled={draft?.lat == null || !(Number(draft.rayon_km) > 0)} data-testid="zone-save"><Save className="h-4 w-4 mr-1" />Enregistrer</Button>
        <p className="text-xs text-orange-700 w-full" data-testid="zone-hint">Cliquez sur la carte pour placer le centre, ou « Pré-remplir » à partir des boutiques du circuit.</p>
      </>}
    </div>
  );
}
